import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Settings from '@/features/settings'

export const Route = createFileRoute('/_authenticated/settings')({
  component: Settings,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Paramètres`,
      },
    ],
  }),
})
